import React from 'react';
import { connect } from 'react-redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { currentAccountSelector } from '../selectors/AuthSelector';

export class AccountRequiredRouteContainer extends BcReactComponent {
  componentDidMount() {
    const { accountPresent } = this.props;
    if (window && !accountPresent) {
      window.location = '/user_dashboard';
    }
  }

  render() {
    return this.props.accountPresent ? this.props.children : null;
  }
}

AccountRequiredRouteContainer.requiresAccount = true;

const mapStateToProps = (state) => ({
  accountPresent: !!currentAccountSelector(state)
});

AccountRequiredRouteContainer.propTypes = {
  children: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.node),
    React.PropTypes.node
  ]).isRequired,
  accountPresent: React.PropTypes.bool
};

export default connect(mapStateToProps)(AccountRequiredRouteContainer);



// WEBPACK FOOTER //
// ./app/containers/AccountRequiredRouteContainer.jsx